import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { KineticLines } from "@/components/Motion";
import { SITE } from "@/config/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy", path: "/privacy-policy",
    body: [
      `${SITE.legalName} ("STJ Innovations", "we") respects the privacy of visitors and business contacts.`,
      "Information you submit through our forms — name, company, contact details and requirement details — is used solely to respond to your enquiry and conduct business discussions. We do not sell or share your information with third parties for marketing.",
      "Drawings, specifications and project details shared with us are treated as confidential business information.",
      "This website may use analytics tools to understand aggregate site usage. You can control cookies through your browser settings.",
      "For any privacy question or request regarding your data, contact us using the details on our Contact page.",
    ],
  },
  terms: {
    title: "Terms of Use", path: "/terms",
    body: [
      `This website is operated by ${SITE.legalName}. By using this website you accept these terms.`,
      "Content on this website — including product descriptions, specifications and images — is provided for general information. Typical specifications are indicative; final product configurations are confirmed in writing during quotation.",
      "Nothing on this website constitutes a binding offer. Quotations, orders and contracts are concluded separately in writing.",
      "Intellectual property on this website, including text, design and imagery, belongs to STJ Innovations unless stated otherwise and may not be reproduced without permission.",
      "We may update these terms from time to time. The version published on this page applies.",
    ],
  },
  cookies: {
    title: "Cookie Policy", path: "/cookie-policy",
    body: [
      "This website uses a small number of cookies to function and to understand aggregate usage.",
      "Essential cookies are required for core functionality such as secure admin access. Analytics cookies, where enabled, help us understand which pages are useful so we can improve the site.",
      "You can block or delete cookies through your browser settings; the public website remains usable without analytics cookies.",
      "Questions about cookies can be sent to us via the Contact page.",
    ],
  },
};

export default function Legal({ kind }) {
  const doc = CONTENT[kind] || CONTENT.privacy;
  return (
    <div data-testid={`legal-${kind}-page`}>
      <SEO title={doc.title} path={doc.path} description={`${doc.title} — ${SITE.legalName}`} />
      <section className="blueprint-dark bg-ink">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <Breadcrumbs dark items={[{ label: doc.title }]} />
          <KineticLines lines={[doc.title]}
            className="mt-4 font-display text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl" />
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        {doc.body.map((p, i) => (
          <p key={i} className="mt-5 text-base leading-[1.85] text-steel first:mt-0" data-testid={`legal-para-${i}`}>{p}</p>
        ))}
        <p className="mt-10 border-t border-line pt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
          {SITE.legalName} · Last updated July 2026
        </p>
      </section>
    </div>
  );
}
